import { useQuery } from '@apollo/client';
import { CreateUserForm } from 'components/site/pages/ResellerPageContent/CreateUserForm';
import { UserList } from 'components/site/pages/ResellerPageContent/UserList';
import { ManagedUsers } from 'graphql/query/__generated__/ManagedUsers';
import { RESELLER_MANAGED_USERS } from 'graphql/query/userQuery';
import { useState } from 'react';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ResellerPageContent = (props: Props): JSX.Element => {
    const [showCreateForm, setShowCreateForm] = useState(false);

    const query = useQuery<ManagedUsers>(RESELLER_MANAGED_USERS);

    const users = query.data?.managedUsers ?? [];

    return (
        <S_ResellerPageContent className={props.className}>
            {showCreateForm ? (
                <CreateUserForm
                    onCreated={() => {
                        query.refetch();
                        setShowCreateForm(false);
                    }}
                    onCanceled={() => {
                        setShowCreateForm(false);
                    }}
                />
            ) : (
                <UserList
                    users={users}
                    onCreateUserclicked={() => {
                        setShowCreateForm(true);
                    }}
                />
            )}
        </S_ResellerPageContent>
    );
};

const S_ResellerPageContent = styled.div`
    display: flex;
    overflow-y: auto;
    flex-wrap: wrap;
`;
